


















































































import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';
import {
  ProductAttributeInfo,
  ProductAttributeType
} from '@eurogast/hub-client-typescript';

@Component
export default class ProductAttributeBadge extends Vue {
  @Prop({required: true})
  public attribute: ProductAttributeInfo;

  public ProductAttributeTypeDto = ProductAttributeType;

  public iconImagePath(attribute: ProductAttributeInfo): string {
    switch (attribute.key) {
      case ProductAttributeType.Tiefgekuehlt:
        return '/images/product_attributes/tiefgekuehlt.svg';
      case ProductAttributeType.Gekuehlt:
        return '/images/product_attributes/gekuehlt.svg';
      case ProductAttributeType.BIO:
        return '/images/product_attributes/bio.svg';
      case ProductAttributeType.Wiegeartikel:
        return '/images/product_attributes/wiegeartikel.svg';
      case ProductAttributeType.VEG:
        return '/images/product_attributes/vegan.svg';
      case ProductAttributeType.GF:
        return '/images/product_attributes/glutenfrei.svg';
      case ProductAttributeType.LF:
        return '/images/product_attributes/laktosefrei.svg';
      case ProductAttributeType.AMAGenussregion:
        return '/images/product_attributes/ama_genussregion.svg';
      default:
        return '';
    }
  }
}
